export default "__VITE_ASSET__91d4940e__"